import { __, concat, join, pipe, replace, split, tail } from 'ramda'
import QrReader from 'react-qr-reader'
import React, { useEffect, useRef } from 'react'

import { useNavigation } from '../../../utils/contexts/NavigationContext'
import SimpleAuthPageTemplate from '../../../components/templates/SimpleAuthPageTemplate'

const ScanQrcodePage = ({ id }) => {
  const navigate = useNavigation()
  const cameraRef = useRef()
  const onClose = () => !!cameraRef.current && cameraRef.current.stopCamera()

  useEffect(() => onClose, [])

  const handleScan = url => {
    if (url) {
      pipe(
        replace('https://', ''), //
        replace('http://', ''),
        split('/'),
        tail,
        join('/'),
        concat('/', __),
        navigate
      )(url)
    }
  }

  return (
    <SimpleAuthPageTemplate title={'Escanear QR Code'} returnTo={`/qrcodes/${id}`} noHeadMargin>
      <QrReader ref={cameraRef} onScan={handleScan} />
    </SimpleAuthPageTemplate>
  )
}

export default ScanQrcodePage
